import { Badge, Button } from '@/_components';

import type { DetailsTab } from './types';
import { INVOICE_DETAILS_TABS } from './types';

type InvoiceDetailsTabBarProps = {
  activeTab: DetailsTab;
  onTabChange: (tab: DetailsTab) => void;
};

/** Matches shortcut `Badge` styling in sidebar `NavButton`. */
const shortcutBadgeClassName =
  'min-w-auto border bg-transparent px-1.5 leading-4 whitespace-nowrap opacity-50 dark:bg-transparent';

export function InvoiceDetailsTabBar({ activeTab, onTabChange }: InvoiceDetailsTabBarProps) {
  return (
    <div className="border-c-border-muted bg-c-background-muted flex shrink-0 items-center gap-1 border-t px-2 py-1 dark:bg-gray-900">
      {INVOICE_DETAILS_TABS.map((tab, i) => {
        const n = i + 1;
        const shortcutLabel = `⌘${n}`;
        const tooltip = `${tab.label} (⌘${n} or ⌥${n})`;
        return (
          <Button
            key={tab.key}
            size="xs"
            as="outline"
            theme="secondary"
            type="button"
            title={tooltip}
            aria-label={tooltip}
            className={
              activeTab === tab.key
                ? 'border-c-border text-c-card-foreground bg-white shadow-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100'
                : 'text-c-card-muted hover:text-c-card-foreground border-transparent bg-transparent dark:text-gray-300 dark:hover:text-gray-100'
            }
            onClick={() => onTabChange(tab.key)}
          >
            <span className="flex w-full min-w-0 items-center justify-between gap-2">
              <span className="truncate">{tab.label}</span>
              <Badge as="light" size="sm" className={shortcutBadgeClassName}>
                {shortcutLabel}
              </Badge>
            </span>
          </Button>
        );
      })}
    </div>
  );
}
